import * as React from 'react';

import {StatsBlockHorizontal} from 'shells/metrics/stats-block-horizontal';
import {Percentage} from 'shells/percentage/percentage';

import type {
    SmsEditionEngagementStatsFragment as SmsEditionEngagementStats,
    SmsDripSequenceFragment_engagementStats as SmsDripSequenceEngagementStats,
} from 'nutshell-graphql-types';

import {
    SmsMessageEngagementModal,
    MessageOptOutModal,
    MessageUndeliverableModal,
} from '../../tooltip-modals';

type Props = {
    isLoading: boolean;
    includeHelp?: boolean;
    stats: SmsEditionEngagementStats | SmsDripSequenceEngagementStats | null | undefined;
    onClickStat?: (filterKey: string) => string;
};

export function EngagementStatsBlock(props: Props) {
    const isLoading = props.isLoading;
    const stats = props.stats;
    const shownEngagementStats = [
        {
            key: '1',
            title: 'Messages sent',
            isLoading: isLoading,
            value: stats ? stats.totalSentCount.toLocaleString() : 0,
            secondaryValue: stats
                ? {
                      value: stats.totalSentCount,
                      nounSingular: 'message',
                      nounPlural: 'messages',
                  }
                : undefined,
            modalComponent: props.includeHelp ? SmsMessageEngagementModal : undefined,
            clickingNavigatesTo: props.onClickStat
                ? props.onClickStat('sentSmsEditions')
                : undefined,
        },
        {
            key: '2',
            title: 'Response rate',
            isLoading: isLoading,
            // @ts-expect-error
            value: <Percentage value={stats ? stats.responseRate : null} precision={2} />,
            secondaryValue: stats
                ? {
                      value: stats.responseCount,
                      nounSingular: 'recipient',
                      nounPlural: 'recipients',
                  }
                : undefined,
            modalComponent: props.includeHelp ? SmsMessageEngagementModal : undefined,
            clickingNavigatesTo: props.onClickStat
                ? props.onClickStat('repliedSmsEditions')
                : undefined,
        },
        {
            key: '3',
            title: 'Undeliverable rate',
            isLoading: isLoading,
            // @ts-expect-error
            value: <Percentage value={stats ? stats.undeliveredRate : null} precision={2} />,
            secondaryValue: stats
                ? {
                      value: stats.undeliveredCount,
                      nounSingular: 'recipient',
                      nounPlural: 'recipients',
                  }
                : undefined,
            modalComponent: props.includeHelp ? MessageUndeliverableModal : undefined,
            clickingNavigatesTo: props.onClickStat
                ? props.onClickStat('bouncedSmsEditions')
                : undefined,
        },
        {
            key: '4',
            title: 'Opt-out rate',
            isLoading: isLoading,
            // @ts-expect-error
            value: <Percentage value={stats ? stats.optoutRate : null} precision={2} />,
            secondaryValue: stats
                ? {
                      value: stats.optoutCount,
                      nounSingular: 'recipient',
                      nounPlural: 'recipients',
                  }
                : undefined,
            modalComponent: props.includeHelp ? MessageOptOutModal : undefined,
            clickingNavigatesTo: props.onClickStat
                ? props.onClickStat('optedOutSmsEditions')
                : undefined,
        },
    ];

    return (
        <div style={{height: 105}}>
            {/* @ts-expect-error */}
            <StatsBlockHorizontal stats={shownEngagementStats} />
        </div>
    );
}
